import { GameLabel, type SocialTagBadgeState } from '@/types/games';

type GameInfoBadgeStateInput = {
    label?: string;
    isNew?: boolean;
    badgeState?: SocialTagBadgeState;
    uniquePlayerCount?: number;
    includeNewBadge?: boolean;
};

type GameInfoBadgeState = {
    hasSocialTag: boolean;
    hasNewBadge: boolean;
    hasBadges: boolean;
};

export const getGameInfoBadgeState = ({
    label,
    isNew = false,
    badgeState,
    uniquePlayerCount,
    includeNewBadge = false
}: GameInfoBadgeStateInput): GameInfoBadgeState => {
    const hasSocialTag = Boolean(badgeState) && (uniquePlayerCount ?? 0) > 0;
    const hasNewBadge = includeNewBadge && isNew && label !== GameLabel.New;

    return {
        hasSocialTag,
        hasNewBadge,
        hasBadges: Boolean(label) || hasNewBadge || hasSocialTag
    };
};

export const buildGameInfoMetaLine = (...parts: (string | null | undefined)[]): string =>
    parts.filter(Boolean).join(' | ');
